<template>
  <div id="blog-page"  class="pageContainer">
    <h1>This is an blog page</h1>
  </div>
</template>
<script>

  import BaseView from '@/components/BaseView'
  import Component from 'vue-class-component'

  @Component
  export default class Blog extends BaseView {

  }

</script>